import { cryptoInstance } from '@/public/fetch/index';
import { indexApi2, ssApi2 } from '@/public/utils/basePath';
const baseURL = indexApi2;
// 获取热门搜索
export const getHot = ({ params, query }) => {
    return cryptoInstance.get(`/v3/hot_search/${params.userId}`, {
        baseURL: indexApi2,
        params: query
    });
};
// 获取搜索历史
export const getHistory = () => {
    return cryptoInstance.get(`/search/history`, {
        baseURL: ssApi2
    });
};
// 重置搜索历史
export const resetHistory = () => {
    console.log(ssApi2, 'ssApi2');
    return cryptoInstance.post(`${ssApi2}/search/history/reset`, {
    /* baseURL: ssApi2 */
    });
};
// 搜索历史-追加
export const historyAdd = (params) => {
    return cryptoInstance.post('/search/history/add', params, {
        baseURL: ssApi2
    });
};
// 获取搜索建议
export const suggestSearch = query => {
    return cryptoInstance.get(`/prompt/fuzzy/search`, {
        baseURL: ssApi2,
        params: query
    });
};
// 获取tab
export const getTab = () => {
    return cryptoInstance.get(`/navigation/tree`, {
        baseURL: ssApi2
    });
};
// 获取课程
export const getCourse = (params) => {
    return cryptoInstance.post('/course/fuzzy/search', params, {
        baseURL: ssApi2
    });
};
// 获取课程内容
export const getCourseContent = (params) => {
    return cryptoInstance.post('/course/content/fuzzy/search', params, {
        baseURL: ssApi2
    });
};
/* 获取早读文章数据 */
export const getReadList = (params) => {
    return cryptoInstance.post('/reading/fuzzy/search', params, {
        baseURL: ssApi2
    });
};
/* 获取直播数据 */
export const getLiveList = (params) => {
    return cryptoInstance.post('/live/fuzzy/search', params, {
        baseURL: ssApi2
    });
};
/* 获取商城数据 */
export const getMallList = (params) => {
    return cryptoInstance.post('/product/fuzzy/search', params, {
        baseURL: ssApi2
    });
};
/* 获取讲师数据 */
export const getLecturerList = (params) => {
    return cryptoInstance.post('/expert/fuzzy/search', params, {
        baseURL: ssApi2
    });
};
/* 根据讲师名精准搜索 */
export const getLecturerDetail = (params) => {
    return cryptoInstance.post('/expert/search', params, {
        baseURL: ssApi2
    });
};
